import { useEffect, useRef, useState } from "react";
import Button from "../Button/Button";

export function Player({ videoSrc, isPlaying }: { videoSrc: string, isPlaying?: boolean }) {
    const [playing, setPlaying] = useState(isPlaying);
    const [percentage, setPercentage] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const video = useRef<HTMLVideoElement>(null);
    const onPlay = () => {
        video.current?.paused ? video.current?.play() : video.current?.pause();
    }

    const formatTimestamp = (time: number, format: "m" | "s") => {
        if (format === "m") return Math.floor(time / 60);
        else if (format === "s") {
            const seconds = Math.floor(time % 60);

            if (seconds < 10) return `0${seconds}`;
            else return seconds;
        }
    }

    const handleVideoTimestamp = (e: Event) => {
        const video = e.target as HTMLVideoElement;
        const duration = video.duration ?? 1;
        const percent = video.currentTime / duration;

        setPercentage(percent * 100);
        setCurrentTime(Math.round(video.currentTime));
    };

    const handleSetTime = (event: any) => {
        if (!video.current) return;

        const clientX = event.clientX;
        const { left: referenceX, width } = event.target.getBoundingClientRect();
        const percentage = (clientX - referenceX) / width;

        setPercentage(percentage * 100);
        video.current.currentTime = video.current.duration * percentage;
    }

    useEffect(() => {
        if (!video.current) return;

        video.current.addEventListener("play", () => { setPlaying(!video.current!.paused) })
        video.current.addEventListener("pause", () => { setPlaying(!video.current!.paused) })
        video.current.addEventListener("timeupdate", handleVideoTimestamp);

        if (isPlaying) video.current.play();
        else video.current.pause();

    }, [video, isPlaying])

    return <div className={`player ${playing ? "is_playing" : ""}`}>
        <video
            ref={video}
            onClick={onPlay}
            className="player_video"
            src={videoSrc} />

        <div className="player_controls">

            <Button type="button" onClick={onPlay} icon={playing ? "Pause" : "Play"} iconSize={48} customCss="p-0" />
            <div className="player_progress">
                <progress value={percentage} max="100" onClick={handleSetTime}></progress>
            </div>
            <span className="text-h3-md">{formatTimestamp(currentTime, "m")}:{formatTimestamp(currentTime, "s")}</span>
        </div>
    </div>
}